Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _merge2=require("lodash/merge");var _merge3=_interopRequireDefault(_merge2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}


var fontDictionary={
"American Typewriter":2.09,
"Baskerville":2.51,
"Georgia":2.27,
"Hoefler Text":2.39,
"Palatino":2.26,
"Times New Roman":2.48,
"Arial":2.26,
"Gill Sans":2.47,
"Gill Sans 300":2.58,
"Helvetica Neue":2.24,
"Lucida Grande":2.05,
"Tahoma":2.25,
"Trebuchet MS":2.2,
"Verdana":1.96,
"Courier New":1.67,
"cursive":1.84,
"fantasy":2.09,
"monospace":1.81,
"serif":2.04,
"sans-serif":1.89};



var absoluteMeasurementUnitsToPixels={
"mm":3.8,
"sm":38,
"pt":1.33,
"pc":16,
"in":96,
"px":1};

var relativeMeasurementUnitsCoef={
"em":1,
"ex":0.5};


var coefficients={
averageFontConstant:2.1675,
widthOverlapCoef:1.25,
heightOverlapCoef:1.05,
lineCapitalCoef:1.15,
lineSpaceHeightCoef:0.2};

var defaultStyle={
lineHeight:1,
letterSpacing:"0px",
fontSize:0,
angle:0,
fontFamily:""};


var degreeToRadian=function degreeToRadian(angle){return angle*Math.PI/180;};

var getFontCharacterConstant=function getFontCharacterConstant(fontFamily){
var firstFont=fontFamily.split(",")[0].replace(/'|"/g,"");
return fontDictionary[firstFont]||coefficients.averageFontConstant;
};

var splitToLines=function splitToLines(text){return text.toString().split(/\r\n|\r|\n/g);};

var getWidestString=function getWidestString(strings){return strings.reduce(function(max,elem){return(
max.length>=elem.length?max:elem);});};


var getSizeWithRotate=function getSizeWithRotate(axisSize,dependentSize,angle){
var angleInRadian=degreeToRadian(angle);
return Math.abs(Math.cos(angleInRadian)*axisSize)+
Math.abs(Math.sin(angleInRadian)*dependentSize);
};

var aproximateTextWidthInternal=function aproximateTextWidthInternal(text,style){
var strLength=getWidestString(splitToLines(text.toString())).length;
return strLength*style.fontSize/style.characterConstant+
style.letterSpacing*Math.max(strLength-1,0);
};

var aproximateTextHeightInternal=function aproximateTextHeightInternal(text,style){
var splittedTextArray=splitToLines(text);
var lineCount=splittedTextArray.length;
var lineHeightNumber=style.fontSize*coefficients.lineCapitalCoef;
var emptySpace=style.fontSize*coefficients.lineSpaceHeightCoef;
return style.lineHeight*(lineHeightNumber*lineCount+emptySpace*(lineCount-1));
};







var convertLengthToPixels=function convertLengthToPixels(length,fontSize){
var attribute=length.match(/[a-zA-Z%]+/)[0];
var value=length.match(/[0-9.,]+/);
var result=void 0;
if(absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)){
result=value*absoluteMeasurementUnitsToPixels[attribute];
}else if(relativeMeasurementUnitsCoef.hasOwnProperty(attribute)){
result=(fontSize?value*fontSize:value*coefficients.defaultFontSize)*
relativeMeasurementUnitsCoef[attribute];
}else{
result=value;
}
return result;
};

var prepareParams=function prepareParams(inputStyle){
var style=(0,_defaults3.default)(inputStyle,defaultStyle);
return(0,_merge3.default)({},style,{
characterConstant:style.characterConstant||getFontCharacterConstant(style.fontFamily),
letterSpacing:convertLengthToPixels(style.letterSpacing,style.fontSize),
fontSize:typeof style.fontSize==="number"?
style.fontSize:
convertLengthToPixels(String(style.fontSize))});

};













var approximateTextSize=function approximateTextSize(text,style){
var params=prepareParams(style);
var height=aproximateTextHeightInternal(text,params);
var width=aproximateTextWidthInternal(text,params);
var widthWithRotate=getSizeWithRotate(width,height,params.angle);
var heightWithRotate=getSizeWithRotate(height,width,params.angle);
return{
width:widthWithRotate*coefficients.widthOverlapCoef,
height:heightWithRotate*coefficients.heightOverlapCoef};

};exports.default=

{
approximateTextSize:approximateTextSize,
convertLengthToPixels:convertLengthToPixels};


/*****************
 ** WEBPACK FOOTER
 ** ./~/victory-core/lib/victory-util/textsize.js
 ** module id = 691
 ** module chunks = 0
 **/